import './LayerFilter.css'

import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import includes from 'lodash/includes'
import remove from 'lodash/remove'
import toLower from 'lodash/toLower'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as Model from 'api/model'
import LayerFilterPropSelect from 'drawer/tabs/layers/filter/LayerFilterPropSelect'
import { ICON_COLOR_DISABLED, ICON_COLOR_ENABLED, PANEL_TITLE_FILTER } from 'drawer/tabs/layers/panels/LayerPanels'
import LayerPanelsExpansion from 'drawer/tabs/layers/panels/LayerPanelsExpansion'

const styles = theme => ({
  root: {
    paddingLeft: 20,
    paddingRight: 20
  },
  notLicensed: {}
})

class LayerFilter extends React.Component {
  constructor (props) {
    super(props)
    const { titleid, layerType } = this.props
    this.selectValues = []
    this.dataPath = `app.config.layerbytitleid[${titleid}].data`
    this.isLicensed = Model.get('config.layout.drawer.tabs.layers.propsFilter.enabled', true)
    this.isVisible = Model.get('config.layout.drawer.tabs.layers.propsFilter.visible', true)
    this.isValidLayerType = toLower(layerType) === 'geojson'
  }

  getSelectValues (geojson) {
    const { layerType, layerPropsFilter } = this.props
    if (this.selectValues.length > 0) {
      return this.selectValues
    } else {
      let selectValues = []
      const featureProperties = geojson?.features?.[0]?.properties ?? null
      if (featureProperties) {
        selectValues = Object.keys(featureProperties)
        // Only show filters in the include array
        if ((this.isLicensed && layerType === 'GeoJSON') || (layerPropsFilter && layerPropsFilter.include)) {
          if (layerPropsFilter && layerPropsFilter.include) {
            remove(selectValues, function (value) {
              return !includes(layerPropsFilter.include, value)
            })
          }
        }
      }
      return selectValues
    }
  }

  handleExpansionPanel = () => {
    console.debug('handleExpansionPanel')
  }

  render () {
    const { classes, titleid } = this.props

    if (!this.isVisible || !this.isValidLayerType) {
      console.log('render - layer not visible or layer type is not valid', titleid, this.isVisible, this.isValidLayerType)
      return null
    }

    const geojson = Model.get(this.dataPath, null)
    this.selectValues = this.getSelectValues(geojson)

    let icon = ''
    let markup = ''

    if (!this.isLicensed) {
      icon = <FilterAltIcon htmlColor={ICON_COLOR_DISABLED} />
      markup = (
        <div className={classes.root}>
          <Typography className={classes.notLicensed}>Upgrade to Pozi Enterprise to access this feature</Typography>
        </div>
      )
      return <LayerPanelsExpansion titleid={titleid} panelTitle={PANEL_TITLE_FILTER} headerIcon={icon} markup={markup} licensed={this.isLicensed} cb={this.handleExpansionPanel}/>
    }

    icon = <FilterAltIcon htmlColor={ICON_COLOR_ENABLED} />
    markup = (
      <div className={classes.root}>
        <LayerFilterPropSelect titleid={titleid} selectValues={this.selectValues} geojson={geojson} />
      </div>
    )
    return <LayerPanelsExpansion titleid={titleid} panelTitle={PANEL_TITLE_FILTER} headerIcon={icon} markup={markup} licensed={this.isLicensed} cb={this.handleExpansionPanel} />
  }
}

LayerFilter.propTypes = {
  classes: PropTypes.object.isRequired,
  layerType: PropTypes.string.isRequired,
  layerPropsFilter: PropTypes.object,
  titleid: PropTypes.string.isRequired,
  panelFeatureTitle: PropTypes.string.isRequired
}

function mapStateToProps (state, ownProps) {
  const { titleid } = ownProps

  const panelFeatureTitle = state.layers[titleid]?.panelFeatureTitle ?? ''
  const layerType = state.layers[titleid]?.type ?? null
  const layerPropsFilter = state.layers[titleid]?.propsFilter ?? null

  return {
    layerType,
    layerPropsFilter,
    panelFeatureTitle
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LayerFilter)
  )
)
